import {
  Hasura_Legal_Document_Types_Enum,
  Legal_Document_Types_Enum,
  useAcceptLegalDocumentMutation,
  useGetAcceptedLegalDocumentsLazyQuery,
} from 'graphql/generated/hasura';
import { LegalDocument } from 'graphql/generated/strapi';

export const useAcceptLegalDocument = () => {
  const [acceptLegalDocumentMutation, { error: acceptLegalDocumentError }] =
    useAcceptLegalDocumentMutation();
  const [fetchAcceptedLegalDocuments] = useGetAcceptedLegalDocumentsLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const acceptLegalDocument = async (
    document: LegalDocument,
  ): Promise<void> => {
    acceptLegalDocumentMutation({
      variables: {
        legal_document_type:
          document.legalDocumentType as unknown as Hasura_Legal_Document_Types_Enum,
      },
    });
  };

  const acceptUnacceptedDocuments = async (
    documents: LegalDocument[],
    userId: string,
  ): Promise<void> => {
    try {
      const acceptedLegalDocuments = await fetchAcceptedLegalDocuments({
        variables: { user_id: userId },
      });
      const acceptedTypes =
        acceptedLegalDocuments.data?.accepted_legal_documents.map(
          (acceptedLegalDocument) =>
            acceptedLegalDocument.legal_document.legal_document_type,
        ) || [];
      const registerPromises = documents.map((document) => {
        if (
          !acceptedTypes.includes(
            document.legalDocumentType as unknown as Legal_Document_Types_Enum,
          )
        ) {
          return acceptLegalDocumentMutation({
            variables: {
              legal_document_type:
                document.legalDocumentType as unknown as Hasura_Legal_Document_Types_Enum,
            },
          });
        }
      });

      if (registerPromises.length) {
        const responses = await Promise.all(registerPromises);
        responses.forEach((response) => {
          if (!response || !response.data) {
            console.error('Failed to accept legal document');
            throw new Error('Failed to accept legal document');
          }
        });
      }
    } catch (error: unknown) {
      console.error('Failed to accept legal document');
      throw new Error('Failed to accept legal document');
    }
  };

  return {
    acceptUnacceptedDocuments,
    acceptLegalDocument,
    acceptLegalDocumentError,
  };
};
